module.exports = __webpack_public_path__ + "static/media/14UNEP19.79d53da6.jpg";